var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: 132,
    viewBox: "0 0 114 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8655 25.4809L13.2652 5.42567C12.3469 2.63552 9.7414 0.75 6.80404 0.75C3.04735 0.75 0.00195312 3.7954 0.00195312 7.55209V115.677C0.00195312 124.542 7.20968 131.717 16.0745 131.677L98.0745 131.305C106.883 131.265 114.002 124.114 114.002 115.306V7.35391C114.002 3.70667 111.045 0.75 107.398 0.75C104.609 0.75 102.121 2.50172 101.181 5.12708L93.8026 25.7268C92.3787 29.7023 88.611 32.3548 84.3883 32.3548H29.3643C25.046 32.3548 21.2155 29.5828 19.8655 25.4809Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23176_19435",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    height: 132
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8655 25.4809L13.2652 5.42567C12.3469 2.63552 9.7414 0.75 6.80404 0.75C3.04735 0.75 0.00195312 3.7954 0.00195312 7.55209V115.677C0.00195312 124.542 7.20968 131.717 16.0745 131.677L98.0745 131.305C106.883 131.265 114.002 124.114 114.002 115.306V7.35391C114.002 3.70667 111.045 0.75 107.398 0.75C104.609 0.75 102.121 2.50172 101.181 5.12708L93.8026 25.7268C92.3787 29.7023 88.611 32.3548 84.3883 32.3548H29.3643C25.046 32.3548 21.2155 29.5828 19.8655 25.4809Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23176_19435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.274 119.848L168.127 134.198L150.559 138.45L70.293 48.401L108.088 33.9418L184.274 119.848Z",
    fill: "url(#paint0_linear_23176_19435)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.929 138.881L97.3523 131.093L45.324 74.313L83.1193 59.8539L152.929 138.881Z",
    fill: "url(#paint1_linear_23176_19435)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23176_19435",
    x1: 173.192,
    y1: 135.551,
    x2: 130.971,
    y2: 25.1877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B60F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23176_19435",
    x1: 142.704,
    y1: 155.262,
    x2: 103.257,
    y2: 52.1498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B60F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingDecoration);
export default __webpack_public_path__ + "static/media/pricingDecoration.39a1b29e800661432863388fd6a7067c.svg";
export { ForwardRef as ReactComponent };